module.exports = __webpack_public_path__ + "static/text-a11fc8d1ea845a3bfa3f53b92362cd9d.svg";